import {
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, fromEvent, Subject } from "rxjs";
import {
    filter,
    takeUntil,
    tap,
} from "rxjs/operators";
import { SearchInputComponent } from "../../controls/search-input/search-input.component";
import { GlobalSearchService } from "../global-search.service";
import { SearchHistoryService } from "../search-history.service";

@Component({
    selector: "app-global-search",
    templateUrl: "./global-search.component.html",
    styleUrls: ["./global-search.component.scss"],
    host: {
        "(document:click)": "onClick($event)",
    },
})
export class GlobalSearchComponent implements OnInit, OnDestroy {
    @ViewChild(SearchInputComponent) searchInputComponent: SearchInputComponent;
    @ViewChild("searchOutput", { read: ElementRef })
        searchOutputComponent: ElementRef;

    searchFieldNotEmpty = false;
    hasHistory = false;
    searchControl = new FormControl("");
    showGlobalSearchResult = false;
    search$: BehaviorSubject<string> = new BehaviorSubject("");
    destroy$ = new Subject<void>();

    onClick(event) {
        if (
            !this.elRef.nativeElement.contains(event.target) &&
            !event.target.classList.contains("ng-option") &&
            !event.target.classList.contains("ng-option-label")
        ) {
            this.showGlobalSearchResult = false;
        }
    }

    constructor(
        private elRef: ElementRef,
        private router: Router,
        private searchService: GlobalSearchService,
        private searchHistoryService: SearchHistoryService
    ) {}

    ngOnInit(): void {
        // get histroy of search
        this.searchHistoryService.hasHistory$
        .subscribe((hasHistory) => {
            this.hasHistory = hasHistory;
        });

        // handle search field input
        this.searchControl.valueChanges
            .pipe(
                tap((keyword: string) => this.handleSearchInput())
            )
            .subscribe();

        // handle navigation events
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.showGlobalSearchResult = false;
            }
        });
    }

    doWeNeedToShowSearchResult(): boolean {
        return this.showGlobalSearchResult
            && (this.searchControl.value.trim() || this.hasHistory);
    }

    doWeNeedToShowHistory(): boolean {
        return this.hasHistory && !this.searchControl.value.trim();
    }

    handleSearchInput() {
        this.showGlobalSearchResult = true;
        if (this.searchControl.value?.length) {
            this.searchService.search(this.searchControl.value);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
    }
}
